// Generated for FP; source: shopify/theme-assets/paf-global-click.js. Do not hand-edit.
(function() {
  "use strict";
  if (window.__fpGlobalClickCollectorV1) return;
  window.__fpGlobalClickCollectorV1 = true;
  var privacyLoadPending = false;
  function loadPrivacyApi() {
    var shopify = window.Shopify;
    if (!shopify || shopify.customerPrivacy || privacyLoadPending || typeof shopify.loadFeatures !== "function") return;
    privacyLoadPending = true;
    try {
      shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function() {
        privacyLoadPending = false;
      });
    } catch (_error) {
      privacyLoadPending = false;
    }
  }
  loadPrivacyApi();
  document.addEventListener("DOMContentLoaded", loadPrivacyApi, { once: true });
  function clean(value, limit) {
    return String(value || "").replace(/\s+/g, " ").trim().slice(0, limit);
  }
  function destinationPath(element) {
    var link = element.closest("a[href]");
    if (!link) return "";
    try {
      var url = new URL(link.getAttribute("href"), window.location.href);
      if (url.protocol !== "http:" && url.protocol !== "https:") return "";
      return (url.host === window.location.host ? "" : url.host) + (url.pathname || "/");
    } catch (_error) {
      return "";
    }
  }
  function targetType(element) {
    if (element.closest("a")) return "link";
    if (element.closest("summary, [aria-expanded]")) return "toggle";
    if (element.closest("button")) return "button";
    return "other";
  }
  function pageSection(element) {
    if (element.closest(".pagination, [data-pagination]")) return "pagination";
    if (element.closest("nav, [role='navigation']")) return "navigation";
    if (element.closest("header")) return "header";
    if (element.closest("footer")) return "footer";
    if (element.closest("main")) return "main";
    return "other";
  }
  function elementKey(element) {
    var marked = element.closest("[data-track-id]");
    var raw = marked && marked.getAttribute("data-track-id");
    if (!raw) raw = element.id || element.getAttribute("name");
    if (raw) return clean(raw, 80).replace(/[^a-zA-Z0-9._:-]/g, "_");
    var path = destinationPath(element);
    return targetType(element) + (path ? ":" + path : "");
  }
  function elementLabel(element) {
    var marked = element.closest("[data-track-label]");
    var raw = marked && marked.getAttribute("data-track-label");
    if (!raw) raw = element.getAttribute("aria-label") || element.getAttribute("title");
    if (!raw) raw = element.innerText || element.textContent;
    if (!raw) {
      var image = element.querySelector("img[alt]");
      if (image) raw = image.getAttribute("alt");
    }
    return clean(raw, 80);
  }
  function deviceCategory() {
    var width = window.innerWidth || 0;
    return width < 768 ? "mobile" : width < 1024 ? "tablet" : "desktop";
  }
  function publish(name, data) {
    loadPrivacyApi();
    var shopify = window.Shopify;
    if (!shopify || !shopify.customerPrivacy || typeof shopify.customerPrivacy.analyticsProcessingAllowed !== "function" || shopify.customerPrivacy.analyticsProcessingAllowed() !== true || !shopify.analytics || typeof shopify.analytics.publish !== "function") return;
    try {
      var result = shopify.analytics.publish("fp:" + name, data);
      if (result && typeof result.catch === "function") result.catch(function() {
      });
    } catch (_error) {
    }
  }
  document.addEventListener("click", function(event) {
    var target = event.target && event.target.nodeType === 3 ? event.target.parentElement : event.target;
    if (!target || !target.closest) return;
    if (target.closest("[data-track-ignore], input, textarea, select, option, form, video, audio, script, style")) return;
    var actionable = target.closest("a, button, summary, [role='button'], [aria-expanded], [data-track-id]");
    if (!actionable) return;
    var section = pageSection(actionable);
    var data = {
      page_path: window.location.pathname || "/",
      element_key: elementKey(actionable),
      element_label: elementLabel(actionable),
      page_section: section,
      destination_path: destinationPath(actionable),
      click_target: targetType(actionable),
      device_category: deviceCategory()
    };
    publish("global_click", data);
  }, { capture: true, passive: true });
})();
